import styled from 'styled-components';

const StatusBadgeContainer = styled.div`
  padding: 8px 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid;
  background: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.primary.background;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.status.warning.background;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.status.error.background;
      case 'SENT':
        return ({ theme }) => theme.status.success.light;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.status.error.background;
      case 'CLAIMED':
        return ({ theme }) => theme.status.success.light;
      case 'ERROR':
        return ({ theme }) => theme.status.error.background;
      case 'HTLC_CREATED':
        return ({ theme }) => theme.status.warning.background;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.status.success.light;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.status.warning.background;
      default:
        return ({ theme }) => theme.primary.background;
    }
  }};
  border-color: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.primary.ultraLight;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.status.warning.lighter;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.status.error.primary;
      case 'SENT':
        return ({ theme }) => theme.status.success.lighter;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.status.error.primary;
      case 'CLAIMED':
        return ({ theme }) => theme.status.success.lighter;
      case 'ERROR':
        return ({ theme }) => theme.status.error.primary;
      case 'HTLC_CREATED':
        return ({ theme }) => theme.status.warning.lighter;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.status.success.lighter;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.status.warning.lighter;
      default:
        return ({ theme }) => theme.primary.ultraLight;
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case 'DRAFT':
        return ({ theme }) => theme.text.secondary;
      case 'TRANSACTION_PENDING':
        return ({ theme }) => theme.text.warning;
      case 'TRANSACTION_FAILED':
        return ({ theme }) => theme.text.error;
      case 'SENT':
        return ({ theme }) => theme.text.success;
      case 'COMMUNICATION_FAILED':
        return ({ theme }) => theme.text.error;
      case 'CLAIMED':
        return ({ theme }) => theme.text.success;
      case 'ERROR':
        return ({ theme }) => theme.text.error;
      case 'HTLC_CREATED':
        return ({ theme }) => theme.text.warning;
      case 'HTLC_CLAIMED':
        return ({ theme }) => theme.text.success;
      case 'HTLC_REFUNDED':
        return ({ theme }) => theme.text.warning;
      default:
        return ({ theme }) => theme.text.secondary;
    }
  }};
`;

const StatusBadge = ({ status, type, deliveryStatus }) => {
  const getStatusText = () => {
    if (type === 'PHYSICAL') {
      switch (deliveryStatus) {
        case 'pending':
          return 'Pending Delivery';
      }
      switch (status) {
        case 'HTLC_CREATED':
          return 'Pending Claim';
        case 'HTLC_CLAIMED':
          return 'Claimed';
        case 'HTLC_REFUNDED':
          return 'Refunded';
      }
    }
    switch (status) {
      case 'DRAFT':
        return 'Draft';
      case 'TRANSACTION_PENDING':
        return 'Processing';
      case 'TRANSACTION_FAILED':
        return 'Failed';
      case 'SENT':
        return 'Sent';
      case 'COMMUNICATION_FAILED':
        return 'Notification Failed';
      case 'CLAIMED':
        return 'Claimed';
      case 'ERROR':
        return 'Error';
      case 'HTLC_CREATED':
        return 'Pending Claim';
      case 'HTLC_CLAIMED':
        return 'Claimed';
      case 'HTLC_REFUNDED':
        return 'Refunded';
      default:
        return status || 'Unknown';
    }
  };

  return (
    <StatusBadgeContainer status={status}>
      {getStatusText()}
    </StatusBadgeContainer>
  );
};

export default StatusBadge;
